import React from 'react'
import './App.css';
// import { withAuthenticator } from '@aws-amplify/ui-react';
import Home from './pages';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import SignIn from './pages/signin'
import SignUp from './pages/signup'
import ForgotPassword from './pages/forgotpassword';
import LearnMore from './pages/learnmore';
import ContactPage from './pages/contact';
import AccountOverview from './pages/account';
import TermsPage from './pages/Terms';
import DemoVideoPage from './pages/demo';
// import { Auth } from 'aws-amplify'



function App() {
  return (
    <div className="App">
      <Router>
        <Switch>
          <Route path='/' component={Home} exact />
          <Route path='/signin' component={SignIn} exact />
          <Route path='/signup' component={SignUp} exact />
          <Route path='/termsofservice' component={TermsPage} exact />
          <Route path='/reset' component={ForgotPassword} exact />
          <Route path='/learnmore' component={LearnMore} exact />
          <Route path='/contact' component={ContactPage} exact />
          <Route path='/demo' component={DemoVideoPage} exact />
          <Route path='/account' component={AccountOverview} exact />
        </Switch>
      </Router>
    </div>
  );
}

export default App;
